import React from 'react';
import './UpdatesPage.css';

const UpdatesPage = () => {
  return (
    <div className="updates-page-container">
      <div className="updates-header">
        <h1>Actualizaciones del Sistema</h1>
        <p className="updates-subtitle">Mantente al día con las últimas mejoras y correcciones.</p>
      </div>
      
      <div className="updates-timeline">
        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">1</span>
            <span className="month">Nov</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Nuevo canal de soporte</h3>
            <p>
              <strong>Solicitudes de ayuda:</strong> Ahora puedes contactar a nuestro equipo de soporte directamente desde la plataforma. Entra a la sección de <strong>Ayuda</strong> (desde el botón <strong>Ayuda</strong> junto al reloj en la parte superior o desde el menú lateral) y haz clic en <strong>&quot;Solicitar ayuda&quot;</strong>. Escribe un asunto breve y una descripción detallada de tu problema o pregunta.
            </p>
            <p>
              <strong>Seguimiento y comentarios:</strong> Cada solicitud queda registrada con su estado (<strong>Abierto</strong>, <strong>En espera</strong> o <strong>Resuelto</strong>). Puedes agregar todos los comentarios que necesites y recibirás un correo electrónico cada vez que el equipo de soporte responda. Si comentas en una solicitud resuelta, esta se vuelve a abrir automáticamente.
            </p>
            <p>
              <strong>Reemplaza a WhatsApp:</strong> Este nuevo canal sustituye al botón de contacto por WhatsApp y está disponible para todas las clínicas, incluidas las que están en periodo de prueba.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">4</span>
            <span className="month">Sep</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Pagos en Órdenes de Laboratorio</h3>
            <p>
              <strong>Sección de pagos:</strong> Las órdenes de laboratorio ahora incluyen una sección de <strong>Pagos</strong> ubicada entre <strong>Adjuntos</strong> e <strong>Historial</strong>, donde puedes registrar el monto, la fecha y una nota asociada a cada pago.
            </p>
            <p>
              <strong>Edición y eliminación:</strong> Como estos pagos son de control administrativo y no requieren trazabilidad de auditoría, pueden editarse o eliminarse en cualquier momento mientras la orden esté abierta.
            </p>
            <p>
              <strong>Total pagado:</strong> La sección muestra el total acumulado de los pagos registrados para que tengas una vista rápida del progreso de cobro de cada orden.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">26</span>
            <span className="month">Jul</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Sobrescritura de citas</h3>
            <p>
              <strong>Citas en horarios ocupados:</strong> Cuando el horario seleccionado coincide con una cita existente, ahora puedes sobrescribirla de forma explícita. Al intentar agendar en un horario ocupado aparecerá un panel con el detalle de la cita en conflicto y un botón &quot;Sobrescribir de todos modos&quot; para confirmar la acción. La sobrescritura queda registrada en el historial de actividad de la cita con la lista de conflictos que fueron sobreescritos.
            </p>
            <p>
              <strong>Bloqueos de calendario:</strong> Los bloqueos de calendario siguen siendo obligatorios y no se pueden sobrescribir; solo es posible sobrescribir conflictos entre citas.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">24</span>
            <span className="month">May</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Imprimir recibos de pago</h3>
            <p>
              <strong>Impresión de recibos:</strong> Ahora puedes imprimir recibos de pago directamente desde la plataforma, facilitando la gestión administrativa y contable. Además, se permite la opción de incluir un concepto personalizado en el recibo para mayor claridad en los registros de pago.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">8</span>
            <span className="month">Abr</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Bloqueos disponibles</h3>
            <p>
              <strong>Bloqueos en calendario:</strong> La funcionalidad de bloqueos ya esta disponible para que puedas reservar espacios en la agenda y evitar que se agenden citas en horarios no disponibles.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">8</span>
            <span className="month">Mar</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Soporte de Ubicaciones</h3>
            <p>
              <strong>Ubicaciones en citas:</strong> Ahora puedes asignar una ubicación a cada cita para un mejor control y organización de los espacios de atención.
            </p>
            <p>
              <strong>Vista de calendario:</strong> Cuando tu organización tiene más de una ubicación configurada, la ubicación se muestra en cada cita del panel lateral del calendario.
            </p>
            <p>
              <strong>Disponibilidad por ubicación:</strong> Al crear o editar una cita, los horarios disponibles toman en cuenta la ocupación de la ubicación seleccionada, evitando conflictos de espacio.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">24</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Roles y Apariencia</h3>
            <p>
              <strong>Gestión de Roles:</strong> Se introdujo la gestión de roles para controlar mejor los permisos de los usuarios dentro de la clínica.
            </p>
            <p>
              <strong>Colores de UI:</strong> Se actualizaron los colores de la interfaz para una experiencia más moderna y accesible.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">17</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Citas y Pacientes</h3>
            <p>
              <strong>Procedimiento en citas:</strong> Se agrego el campo Procedimiento en la creacion y edicion de citas para mayor detalle clínico.
            </p>
            <p>
              <strong>Proxima cita en paciente:</strong> En la vista de detalle del paciente se muestra un resumen de la proxima cita (fecha, procedimiento, doctor y notas).
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">16</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Pacientes</h3>
            <p>
              <strong>Listado de pacientes:</strong> Ahora se muestran los pacientes en orden alfabético, y se añadió un indicador del numero de pacientes en cada sección (activos y archivados).
            </p>
            <p>
              <strong>Creación de pacientes:</strong> Al seleccionar la fecha de nacimiento se muestra un calendario más robusto para evitar errores.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">14</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Calendario y Planes de Tratamiento</h3>
            <p>
              <strong>Calendario:</strong> Ahora puedes filtrar las citas por usuario en la vista mensual usando bolitas con iniciales. Selecciona o deselecciona doctores para mostrar solo sus citas.
            </p>
            <p>
              <strong>Planes de Tratamiento:</strong> Ya se pueden enviar por correo los planes de tratamiento.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">13</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Impresion de Plan de Tratamiento</h3>
            <p>
              <strong>Planes de Tratamiento:</strong> Se optimizo la plantilla de impresion para verse mas compacto, sin fondos de color y mejor distribución.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">12</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Proveedores</h3>
            <p>
              <strong>Proveedores:</strong> Ahora puedes llevar el registro de proveedores dentro del sistema.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">11</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Fecha Efectiva de Pagos</h3>
            <p>
              <strong>Pagos:</strong> Ahora puedes seleccionar la fecha efectiva del pago. Los reportes financieros y las listas de pagos usan ahora esta fecha.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">9</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Mejoras en Planes de Tratamiento</h3>
            <p>
              <strong>Planes de Tratamiento:</strong> Se añadieron mejoras para permitir nuevos estados en los planes de tratamiento.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">8</span>
            <span className="month">Feb</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Mejoras en Odontograma</h3>
            <p>
              <strong>Odontograma:</strong> Se añadieron cambios para crear un Odontograma inicial, uno de seguimiento y para dar de alta pacientes directamente desde esta sección.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">29</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Cumplimiento normativo</h3>
            <p>
              <strong>Vista de Pacientes Archivados:</strong> Se ha añadido una nueva pestaña en la sección de Pacientes que permite visualizar todos los pacientes que han sido Archivados. Esta vista es de solo lectura y muestra toda la información histórica de los pacientes archivados.
            </p>
            <p>
              <strong>Prescripciones:</strong> Se ha removido la opción de eliminar prescripciones para cumplir con las normativas médicas y legales. Ahora, las prescripciones solo pueden estar en estado "Borrador", "Activa", o "Cancelada". Esta medida asegura la integridad y trazabilidad de los registros médicos.
            </p>
            <p>
              <strong>Planes de tratamiento:</strong> Se puede asignar descuentos a los conceptos dentro de un plan de tratamiento, permitiendo mayor flexibilidad en la gestión de costos para los pacientes.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">28</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Mejoras en comunicación y navegación</h3>
            <p>
              <strong>Mensajes Personalizados por WhatsApp:</strong> Ahora puedes personalizar el mensaje por defecto que se envía al contactar pacientes por WhatsApp desde la configuración de la clínica. Utiliza la variable {'{nombre}'} para insertar automáticamente el nombre del paciente en tus mensajes. Esta configuración facilita la comunicación con tus pacientes manteniendo un tono profesional y personalizado.
            </p>
            <p>
              <strong>Planes de tratamiento:</strong> Se mejora la navegación al acceder a planes de tratamiento en dispositivos móviles.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">27</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Actualización de Terminología Dental y Calendario</h3>
            <p>
              <strong>Odontograma:</strong> La sección anteriormente conocida como "Notas Dentales" ahora se muestra como "Odontograma" en toda la aplicación. Este cambio alinea la terminología con los estándares médicos dentales y mejora la claridad para los profesionales de la salud dental.
            </p>
            <p>
              <strong>Indicadores de Festivos Oficiales:</strong> El calendario mensual ahora muestra los días festivos oficiales de México con un pequeño icono (🏛️) para que el doctor esté consciente de cuándo la clínica podría no estar disponible. Al pasar el ratón sobre el icono, aparece el nombre del festivo.
            </p>
            <p>
              <strong>Procedimientos:</strong> Los procedimientos permiten el desglose de impuestos para cumplir con las normativas fiscales mexicanas (CFDI 4.0). Ahora puedes especificar múltiples impuestos por procedimiento, y estos se reflejarán correctamente en las facturas y reportes.
            </p>
            <p>
              <strong>Formas de pago:</strong> Las formas de pago ahora incluyen códigos SAT (Servicio de Administración Tributaria) para facilitar la correcta categorización fiscal en México. Al seleccionar una forma de pago al registrar un pago, el código SAT correspondiente se incluirá automáticamente en la factura electrónica.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">25</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Mejoras en Reportes Financieros e Incorporación de Datos Fiscales</h3>
            <p>
              <strong>Distribución por Forma de Pago:</strong> Los reportes financieros ahora incluyen una nueva sección que muestra cómo se distribuyen los ingresos entre las diferentes formas de pago (efectivo, tarjeta, transferencia, etc.). Esta información se presenta tanto en formato de tabla como en una gráfica circular para facilitar el análisis visual.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Código SAT en Procedimientos:</strong> Se ha añadido la capacidad de registrar el Código SAT (Servicio de Administración Tributaria) para cada procedimiento. Esto facilita la facturación correcta según la normativa fiscal mexicana (CFDI 4.0).
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Información Fiscal de Doctores:</strong> Los doctores ahora pueden registrar datos fiscales como RFC, régimen fiscal y otros datos requeridos para la emisión de facturas y comprobantes fiscales digitales.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Creación rápida de pacientes:</strong> Se corrige un problema que impedía la creación rápida de pacientes desde la agenda en dispositivo móvil.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">24</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Precisión en Reportes y Calendario</h3>
            <p>
              <strong>Zona Horaria en Reportes:</strong> Se ha perfeccionado la generación de reportes para respetar estrictamente la zona horaria de la organización. Esto asegura que las citas y pagos realizados en los últimos momentos del mes se contabilicen correctamente en su mes correspondiente.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Visibilidad en Calendario:</strong> Solucionado un caso donde las citas agendadas cerca de la medianoche (fin de mes/día) no aparecían en la vista mensual debido a conversiones de zona horaria. Ahora el calendario muestra la totalidad de las citas del periodo seleccionado.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">23</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Gestión de Usuarios y Pacientes Renovada</h3>
            <p>
              <strong>Perfil de Usuario Detallado:</strong> Hemos añadido una nueva página dedicada para ver y gestionar la información completa de cada usuario.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Acciones Mejoradas:</strong> Ahora puedes gestionar roles y eliminar usuarios de manera más segura desde su página de detalles, con una zona de peligro clara para acciones destructivas.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Listas Unificadas:</strong> Tanto la lista de usuarios como la de pacientes ahora comparten un diseño limpio y moderno. Las filas son más amplias para facilitar el clic y la navegación a los detalles es más intuitiva.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Corrección en Reportes Financieros:</strong> Se solucionó un problema donde el reporte financiero diario no respetaba la zona horaria de la organización al agrupar los pagos. Ahora los cortes diarios son precisos según la hora local de la clínica.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">22</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Mejoras en la Navegación</h3>
            <p>
              <strong>Insumos en Menú Principal:</strong> La sección de Insumos ha sido movida de la Configuración al menú principal lateral para facilitar su acceso y gestión diaria.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">21</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Mejoras Generales y Correcciones</h3>
            <p>
              <strong>Fecha de Nacimiento Opcional:</strong> Ahora es posible crear y editar pacientes sin necesidad de ingresar su fecha de nacimiento obligatoriamente. Esta mejora aplica tanto en el formulario principal como en el registro rápido desde la agenda.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Seguridad en Reportes:</strong> El acceso a la sección de reportes ha sido restringido. Ahora es exclusivo para Administradores y Dueños, asegurando que la información sensible del negocio esté protegida.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Estabilidad de la Aplicación:</strong> Se corrigió un problema que causaba que la aplicación se recargara visualmente cada 5 minutos. Las actualizaciones en segundo plano ahora son transparentes para el usuario.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">20</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Mejoras de Navegación e Impresión</h3>
            <p>
              <strong>Vista de Citas:</strong> Al hacer clic en el nombre del paciente dentro de la lista de citas, ahora se navega directamente al expediente del paciente en lugar de editar la cita. Para editar, utilice el icono de lápiz.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Planes de Tratamiento e Historia Clínica:</strong> Ahora se respeta y muestra correctamente el título del profesional configurado en el perfil al imprimir los planes de tratamiento y la historia clínica.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Insumos:</strong> Se añadió la capacidad de agregar un contador opcional al crear y editar insumos.
            </p>
            <p style={{ marginTop: '10px' }}>
              <strong>Calendario y Correos:</strong> Integración con calendarios (Outlook, Google, Apple) ahora disponible. Los correos incluyen invitaciones para agregar y gestionar citas en su calendario.
            </p>
          </div>
        </div>

        <div className="update-card">
          <div className="update-date-badge">
            <span className="day">19</span>
            <span className="month">Ene</span>
            <span className="year">2026</span>
          </div>
          <div className="update-content">
            <h3>Cambio en Configuración de Zona Horaria</h3>
            <p>
              La configuración de <strong>Zona Horaria</strong> se ha movido. Antes se encontraba en el perfil de usuario, 
              ahora se encuentra en la sección de <strong>Configuración de Clínica</strong>. 
              Esto permite una gestión más centralizada para toda la organización.
            </p>
          </div>
        </div>

        {/* Future updates will be added here */}
      </div>
    </div>
  );
};

export default UpdatesPage;
